import Stepper from 'bs-stepper'

up.compiler('.bs-stepper', (element) => {
  if(!element.classList.contains('inactive')) {
    var stepper = new Stepper(element, {animation: true})
  }
})
